import { lazy } from "react";

const verticalRecutter = lazy(() => import("./verticalRecutter"));

const verticalcutterRoutes = [
  {
    path: "/ordertransfer",
    component: verticalRecutter,
  },
];

export default verticalcutterRoutes;
